export default "__VITE_ASSET__D76aTdX0__"